<template>
  <el-dialog
      :visible.sync="visible"
      title="选择原料"
      :close-on-click-modal="false"
      :close-on-press-escape="false"
      width="80%"
  >
    <div class="table-bar" style="margin-bottom: 0">
      <el-form
          :inline="true"
          :model="dataForm"
          @keyup.enter.native="reload()"
          ref="queryForm"
          class="query-form"
      >
        <el-form-item prop="orderCode" label="外销合同号：">
          <el-input
              v-model="dataForm.orderCode"
              size="mini"
              clearable
              type="text"
              placeholder="请输入外销合同号"
          ></el-input>
        </el-form-item>
        <el-form-item prop="storeName" label="仓库：">
          <el-input
              v-model="dataForm.storeName"
              size="mini"
              clearable
              type="text"
              placeholder="请输入仓库名称"
          ></el-input>
        </el-form-item>
        <el-form-item prop="productName" label="品名：">
          <el-input
              v-model="dataForm.productName"
              size="mini"
              clearable
              type="text"
              placeholder="请输入品番号/品名/颜色/规格"
          ></el-input>
        </el-form-item>
        <el-form-item>
          <el-button type="primary" @click="reload" size="mini">查询</el-button>
          <el-button @click="reset" size="mini">重置</el-button>
          <el-button type="primary" @click="submitSel" size="mini">确定选择</el-button>
        </el-form-item>
      </el-form>
    </div>
    <el-table
        ref="countSelDialogTable"
        v-loading="dataListLoading"
        :data="dataList"
        border
        @selection-change="dataListSelectionChangeHandle"
        style="width: 100%"
        :max-height="maxTableHeight"
        row-key="id"
    >
      <el-table-column
          type="selection"
          header-align="center"
          align="center"
          width="50"
          :reserve-selection="true"
      ></el-table-column>
      <el-table-column
          type="index"
          header-align="center"
          align="center"
          width="50"
          label="行号"
      ></el-table-column>
      <el-table-column label="订单编号" min-width="160" prop="agreementCode" header-align="center" align="center"
                       :show-overflow-tooltip="true">
      </el-table-column>
      <el-table-column label="仓库名称" min-width="160" prop="storageName" header-align="center" align="center"
                       :show-overflow-tooltip="true">
      </el-table-column>
      <el-table-column label="品名" width="160" prop="name" header-align="center" align="center"
                       :show-overflow-tooltip="true">
      </el-table-column>
      <el-table-column label="颜色" width="100" prop="color" header-align="center" align="center"
                       :show-overflow-tooltip="true">
      </el-table-column>
      <el-table-column label="规格" align="center" prop="size" :show-overflow-tooltip="true">
      </el-table-column>
      <el-table-column label="幅宽" align="center" prop="attr1" :show-overflow-tooltip="true">
      </el-table-column>
      <el-table-column
          label="克重"
          prop="attr2"
          header-align="center"
          align="center"
          width="100"
          :show-overflow-tooltip="true"
      >
      </el-table-column>
      <el-table-column
          prop="count"
          label="库存数量"
          header-align="center"
          align="center"
          width="100"
      ></el-table-column>
    </el-table>
    <el-pagination
        :current-page="page"
        :page-sizes="[10, 20, 50, 100]"
        :page-size="limit"
        :total="total"
        layout="total, sizes, prev, pager, next, jumper"
        @size-change="pageSizeChangeHandle"
        @current-change="pageCurrentChangeHandle"
    >
    </el-pagination>
  </el-dialog>
</template>

<script>
import mixinViewModule from '@/mixins/view-module'

export default {
  name: 'count-sel-dialog',
  mixins: [mixinViewModule],
  data () {
    return {
      mixinViewModuleOptions: {
        getDataListURL: '/store/page',
        getDataListIsPage: true,
        activatedIsNeed: false
      },
      dataForm: {},
      maxTableHeight: 400,
      visible: false
    }
  },
  methods: {
    //确定选择
    submitSel () {
      this.$emit('change', this.dataListSelections)
      this.visible=false
    },
    beforeTableBinding(dataList){
      if(!dataList||dataList.length===0){
        return
      }
      dataList.forEach(row=>{
        row.id=row.agreementId+row.storageId+row.productId
      })
    },
    init () {
      this.reload()
      this.visible = true
    },
    reset () {
      this.$refs.queryForm.resetFields()
    },
    clearSelection () {
      if (this.$refs.countSelDialogTable) {
        this.$refs.countSelDialogTable.clearSelection()
      }
    },
  }
}
</script>

<style scoped>

</style>
